$(function(){
    //process the request an invite form.
    $('#request-invite-form').submit(function(event) {
        // stop the form from submitting the normal way and refreshing the page
        event.preventDefault();
        //disable the button.
        $('#invite-button').removeClass('btn-cta-primary').html('Please Wait...').attr('disabled', true);
        let formData = $(this).serializeArray();

        // trim all inputs
        formData = formData.map(function(input){
            input.value = input.value.trim();
            return input
        });

        // convert to string
        formData = $.param(formData);

        // process the form
        $.ajax({
            type        : 'POST',
            url         : '/signup',
            data        : formData
        }).success(function(data) {
            $('#request-invite-body').hide();
            $('#invite-failed').hide();
            $('#invite-success').show();
        }).error(function(data){
            grecaptcha.reset(signupRecaptcha);
            $('#invite-failed').show();
            $('#invite-button').addClass('btn-cta-primary').html('Send Request').attr('disabled', false);
        });
    });
});